'use client';

import { Liff } from '@line/liff';
import React, { createContext } from 'react';

import type { Profile } from '@liff/get-profile';

interface GlobalContextType {
  liff: Liff | null;
  liffProfile: Profile | null;
  liffError: string | null;
}

export const GlobalContext = createContext<GlobalContextType | undefined>(
  undefined
);

interface GlobalContextProviderProps {
  children: React.ReactNode;
  value: GlobalContextType;
}

export const GlobalContextProvider = ({
  children,
  value,
}: GlobalContextProviderProps) => {
  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};
